import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./galerieStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function Galerie() {
    const navigate = useNavigate();

    const [gallery, setGallery] = useState([]);

    useEffect(() => {
        document.title = "DJ - EMAN"

        getGallery();
    }, []);

    const getGallery = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/gallery", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.ok) {
                const data = await response.json();
                setGallery(data);
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const publicUrl = process.env.PUBLIC_URL || '';
    const fallbackImage = `${publicUrl}/img/cookie.png`;

    return (
        <div className="galerieContainer">
            <h1>Galerie</h1>
            <h2>Sehe dir die Bilder der letzten Events an</h2>
            <div className="picturesContainer">
                {gallery.map((src, i) => {
                        return (
                            <div className="pictureContainer" key={i}>
                                <img
                                    src={`https://djeman.de:8443/api/v1/gallery/image/${src.uuid}`}
                                    alt={src.name}
                                    loading="lazy"
                                    decoding="async"
                                    onError={(e) => {
                                        const img = e.currentTarget;
                                        if (img.src !== fallbackImage) img.src = fallbackImage;
                                    }}
                                />
                                <h1>{src.name}</h1>
                            </div>
                        );
                    })
                }
            </div>
            <h3>Alle hier gezeigten Bilder liegen im Eigentum von Elmar Fichtner und dürfen ohne ausdrückliche schriftliche Genehmigung weder gespeichert, vervielfältigt noch veröffentlicht werden.
                Alle Bilder sind Urheberrechtlich geschützt und unterliegen dem Schutz des Urheberrechts gemäß §2 UrhG. wodurch Zuwiderhandlungen rechtlich verfolgt werden.
                Auf sämtlichen Fotografien, auf denen Personen eindeutig identifizierbar sind, wurden die betroffenen Personen im Vorfeld durch eine öffentliche Durchsage über die Anfertigung und mögliche
                Veröffentlichung der Aufnahmen informiert.</h3>
        </div>
    )
}
